import { CardPaymentsComponents } from './components'
import { CardPaymentsNavigation } from './navigation'
import { CardPaymentsScreens } from './screens'
import { CardPaymentsStatsig } from './statsig'
import { CardPaymentsStore } from './store'

export const CardPayments = {
  Navigation: CardPaymentsNavigation,
  Screens: CardPaymentsScreens,
  Icons: {},
  Statsig: CardPaymentsStatsig,
  Store: CardPaymentsStore,
  Components: CardPaymentsComponents,
}
